import { ISVGAnimationsSettings } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import { IOption } from '@/types/global.ts'
import TrashButton from '@/shared/Buttons/TrashButton'
import FormField from '@/shared/Forms/FormField'
import SearchDropdownInput from '@/shared/Inputs/SearchDropdownInput'
import EquipmentDropdown from '@/pages/Equipment/components/Common/EquipmentDropdown'
import SvgChartSettingsCard from '@/pages/Dashboards/Charts/SVGChart/SvgChartSettingsSidePage/SvgChartSettingsCard'
import ParameterDropdown from '@/pages/Parameters/components/ParameterDropdown'
import SVGSettingsConditionDropdown from '@/pages/Dashboards/Charts/SVGChart/SvgChartSettingsSidePage/SvgChartConditionOperatorDropdown'
import NumberInput from '@/shared/Inputs/NumberInput'
import DropdownInput from '@/shared/Inputs/DropdownInput'
import Toggle from '@/shared/Inputs/Toggle'
import PlayButton from '@/shared/Buttons/PlayButton'
import ToolTip from 'src/shared/Common/Tooltip'
import { IParameter } from '@/pages/Parameters/parameters.types'

interface IProps {
  settings: ISVGAnimationsSettings
  onChange: (index: number, value: any, key: string, nestedKey: 'movements') => void
  onDelete: (index: number, nestedKey: 'movements') => void
  onPlay: (settings: ISVGAnimationsSettings, key: 'movements') => void

  nodeOptions: IOption<string>[]
  onNodeOptionHover: (id: string) => void

  index: number
}

const SvgChartMovementSettingsRow = (props: IProps) => {
  const handleChange = (val, name) => props.onChange(props.index, val, name, 'movements')

  return (
    <div className="flex-lines gap16">
      <div className="inline-flex-gap flex-space-between width100">
        <h5 className="text-heading-5">Узел {props.index + 1}</h5>
        <div className="inline-flex-gap gap12">
          <ToolTip text="Проиграть превью" position="left" delay={50}>
            <PlayButton onClick={() => props.onPlay(props.settings, 'movements')} size="default" />
          </ToolTip>
          <TrashButton onClick={() => props.onDelete(props.index, 'movements')} />
        </div>
      </div>
      <div className="inline-flex-gap gap16">
        <FormField label="ID узла" required={true} fullWidth={true}>
          <SearchDropdownInput
            options={props.nodeOptions}
            selectedOption={props.settings.node_id as any}
            title="Выберите из списка"
            onSelect={handleChange}
            name="node_id"
            onOptionHover={props.onNodeOptionHover}
          />
        </FormField>
        <FormField label="Устройство" required={true} fullWidth={true}>
          <EquipmentDropdown
            value={props.settings.device_id}
            name="device_id"
            onChange={handleChange}
            placeholder="Выберите из списка"
          />
        </FormField>
      </div>
      <SvgChartSettingsCard>
        <div className="flex-lines gap12">
          <p className="text-caption" style={{ color: 'var(--text-description)' }}>
            Условие
          </p>
          <div className="inline-flex-gap gap16">
            <FormField label="Переменная" fullWidth={true}>
              <ParameterDropdown
                value={props.settings.parameter_id as IParameter['id']}
                name="parameter_id"
                onChange={handleChange}
                placeholder="Выберите из списка"
              />
            </FormField>
            <FormField label="Оператор" style={{ width: '100px', flexShrink: 0 }}>
              <SVGSettingsConditionDropdown
                title="="
                value={props.settings.condition}
                name="condition"
                onChange={handleChange}
              />
            </FormField>
            <FormField label="Значение" fullWidth={true}>
              <NumberInput
                value={props.settings.value}
                name="value"
                onChange={handleChange}
                fullWidth={true}
                placeHolder="Введите значение"
              />
            </FormField>
          </div>
        </div>
      </SvgChartSettingsCard>
      <SvgChartSettingsCard>
        <div className="flex-lines gap12">
          <div className="inline-flex-gap gap8 center">
            <p className="text-caption" style={{ color: 'var(--text-description)' }}>
              Движение
            </p>
          </div>
          <div className="inline-flex-gap gap16">
            <FormField label="Направление" fullWidth={true}>
              <DropdownInput
                options={movementDirectionOptions}
                selectedOption={props.settings.direction as any}
                title="Выберите направление"
                onSelect={handleChange}
                name="direction"
              />
            </FormField>
            <FormField label="Длительность (сек)" fullWidth={true}>
              <NumberInput
                value={props.settings.duration}
                name="duration"
                placeHolder="Введите значение"
                onChange={handleChange}
                fullWidth={true}
              />
            </FormField>
            <FormField label="Дистанция (%)" fullWidth={true}>
              <NumberInput
                value={props.settings.distance}
                name="distance"
                placeHolder="Введите значение"
                onChange={handleChange}
                fullWidth={true}
              />
            </FormField>
          </div>
          <div className="inline-flex-gap gap8 center">
            <Toggle name="cycle" checked={props.settings.cycle} onChange={handleChange} size="large" />
            <p className="text-nm">Зациклить анимацию</p>
          </div>
        </div>
      </SvgChartSettingsCard>
    </div>
  )
}

const movementDirectionOptions: IOption<ISVGAnimationsSettings['direction']>[] = [
  { value: 'left', title: 'Влево' },
  { value: 'right', title: 'Вправо' },
  { value: 'top', title: 'Вверх' },
  { value: 'bottom', title: 'Вниз' },
]

export default SvgChartMovementSettingsRow
